import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { JaldeeVerifyLevelService } from 'src/app/services/jaldee-verify-level.service';
import { VerifyLogDetailsComponent } from './verify-log-details/verify-log-details.component';

@Component({
  selector: 'app-verify-log',
  templateUrl: './verify-log.component.html',
  styleUrls: ['./verify-log.component.css']
})
export class VerifyLogComponent implements OnInit {
 
  verificationDetails: any = [] ;
  accountId: any;
  accountType: any;

  constructor(private jaldeeverifyService: JaldeeVerifyLevelService, private dialog: MatDialog) { }

  ngOnInit() {
    this.accountType = this.jaldeeverifyService.getTypeofAccount();
    if (this.accountType === 'corporate') {
      this.jaldeeverifyService.getCorporateVerificationLogs(this.jaldeeverifyService.getCorporateId())
      .subscribe(res => {
        this.verificationDetails = res;
      });

    } else if (this.accountType === 'account') {
      this.jaldeeverifyService.getVerificationLogs(this.jaldeeverifyService.getAccountDetails())
      .subscribe(res => {
        this.verificationDetails = res;
      });

    }
    
  

  }
  showDetails(type, details) {
    console.log('details.....' + JSON.stringify(details));
    const dialogRef = this.dialog.open(VerifyLogDetailsComponent,{
      width: '1000px',
      data: {'type': type, 'value': details}

    });
     dialogRef.afterClosed().subscribe(result => {
     console.log(result);
    });

  }

}
